export default __webpack_public_path__ + "static/media/Email_icon.6e361f2d.svg";